import { makeStyles } from "@material-ui/core";
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Card,
  ListItemButton,
  Typography,
} from "@mui/material";
import { styled } from "@mui/material/styles";

export const useStyles = makeStyles((theme) => ({
  datepickerClass: {
    width: "238px !important",
    height: "56px !important",
    fontFamily: "Roboto !important",
    fontSize: "16px !important",
  },
  completed: {
    backgroundColor: "red",
  },
}));

export const ModernAccordion = styled(Accordion)({
  boxShadow: "0 2px 8px rgba(0, 0, 0, 0.08)",
  border: "none",
  marginBottom: "16px",
  overflow: "hidden",
  "&:before": {
    display: "none",
  },
  "&.Mui-expanded": {
    margin: "0 0 16px 0",
  },
  "&.MuiAccordion-root": {
    border: "none",
    "&:before": {
      display: "none",
    },
  },
});

export const ModernAccordionSummary = styled(AccordionSummary)({
  minHeight: "40px",
  padding: "0 16px",
  transition: "all 0.3s ease-in-out",
  "&.Mui-expanded": {
    minHeight: "40px",
    backgroundColor: "rgba(0, 0, 0, 0.02)",
  },
  "& .MuiAccordionSummary-content": {
    margin: "8px 0",
    alignItems: "center",
    "&.Mui-expanded": {
      margin: "8px 0",
    },
  },
  "& .MuiAccordionSummary-expandIconWrapper": {
    color: "white",
    transition: "transform 0.3s ease-in-out",
    "&.Mui-expanded": {
      transform: "rotate(180deg)",
    },
  },
});

export const ModernAccordionDetails = styled(AccordionDetails)({
  padding: "24px",
  backgroundColor: "#FAFAFA",
  borderTop: "1px solid #E5E7EB",
});

export const ActionCard = styled(Card)({
  border: "1px solid #E5E7EB",
  boxShadow: "0 1px 3px rgba(0, 0, 0, 0.05)",
  "&:hover": {
    boxShadow: "0 4px 12px rgba(0, 0, 0, 0.1)",
  },
});

export const CompactListItemButton = styled(ListItemButton)({
  padding: "2px 8px",
  minHeight: "28px",
  marginBottom: "2px",
  "& .MuiListItemIcon-root": {
    minWidth: "24px",
  },
  "& .MuiListItemText-primary": {
    fontSize: "12px",
    fontWeight: 500,
  },
});

export const SectionTitle = styled(Typography)({
  fontSize: "11px",
  fontWeight: 600,
  color: "#374151",
  marginBottom: "6px",
  textTransform: "uppercase",
  letterSpacing: "0.05em",
});
